import {Component, OnInit, ViewChild} from '@angular/core';
import {DataConcessionService} from '../utils/data-services/dataConcession.service';
import {Router} from '@angular/router';
import {DataCreationConcessionService} from '../utils/data-services/dataCreation-concession.service';
import {DataContactService} from '../utils/data-services/dataContact.service';
import {MatTableDataSource} from '@angular/material/table';
import {DataDealershipSynchronizationService} from '../utils/data-services/data-dealership-synchronization.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import swal from 'sweetalert2';
import {PngoDealershipService} from "../utils/data-services/pngo-dealership.service";

@Component({
  selector: 'app-gestion-mapping-planngo',
  templateUrl: './gestion-mapping-planngo.component.html',
  styleUrls: ['./gestion-mapping-planngo.component.scss']
})
export class GestionMappingPlanngoComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  variable: any;
  /* Variable list for the Textarea components */
  sort = null;
  concessionID: any;
  nom: any;
  ELEMENT_DATA: any;
  dataSource: any;
  groups = [];
  search: any;
  originalDataSource = null;
  selectedGroup = null;
  groupsArray = {
    filtered: null,
    default: null
  };
  typesArray = [];
  selectedType = null;
  activeDealership = [];
  combineDealership = [];
  pngoDealership = [];

  // syncLoader
  titleLoader = 'Synchronisation de la concession en cours';
  isSyncLoading = false;

  // tslint:disable-next-line:max-line-length
  constructor(private dataSynchro: DataDealershipSynchronizationService, private dataConcessionService: DataConcessionService, private pngoDealershipService: PngoDealershipService, private route: Router, private dataService: DataCreationConcessionService, private  dataContactService: DataContactService) {  }
  displayedColumns: string[] = ['concession_id', 'nom_concession', 'brand', 'configuration', 'informations', 'operation', 'mobilite', 'synchro'];

  ngOnInit() {
    this.getDealershipType();
    this.dataConcessionService.getConcession().subscribe(data => {
      this.dataService.getGroups().subscribe(groups => {
        this.groups = groups.records;

        this.variable = [];
        this.groupsArray.filtered = groups.records;
        this.groupsArray.default = groups.records;
        for (const concession of data.records) {
          if (this.groups.filter(x => x.groupe_id == concession.groupe_id)[0]) {
            concession.group = this.groups.filter(x => x.groupe_id == concession.groupe_id)[0].nom;
          }
          this.variable.push(concession);
        }
        this.ELEMENT_DATA = this.variable;
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.originalDataSource = this.ELEMENT_DATA;
        let bigestId = 0;
        for (const concession of data.records) {
          if (concession.concession_id > bigestId) {
            bigestId = concession.concession_id;
          }
        }
        sessionStorage.setItem('autoIncrement', (bigestId + 1).toString());
        this.search = localStorage.getItem('mappingPlanngoFilter') != null ? localStorage.getItem('mappingPlanngoFilter') : '';
        this.dataSource.filter = this.search.trim().toLowerCase();
        this.selectedGroup = localStorage.getItem('filterPlanngoDealershipGroup') != null ? localStorage.getItem('filterPlanngoDealershipGroup') : null;
        this.selectedType = localStorage.getItem('filterPlanngoDealershipType') != null ? localStorage.getItem('filterPlanngoDealershipType') : null;
        this.activeDealership = JSON.parse(localStorage.getItem('filterPlanngoDealershipActive'));
        this.combineDealership = JSON.parse(localStorage.getItem('filterPlanngoDealershipCombine'));
        this.dataSource.filter = this.search.trim().toLowerCase();
        this.paginator.pageIndex = localStorage.getItem('pageIndexDealership') != null ? parseInt(localStorage.getItem('pageIndexDealership')) : null;
        this.paginator.pageSize = localStorage.getItem('pageSizeDealership') != null ? parseInt(localStorage.getItem('pageSizeDealership')) : null;
        this.dataSource.paginator = this.paginator;
        this.filterDealership();
      });
    });
    this.paginator.pageIndex = localStorage.getItem('pageIndexMapping') != null ? parseInt(localStorage.getItem('pageIndexMapping')) : null;
    this.paginator.pageSize = localStorage.getItem('pageSizeMapping') != null ? parseInt(localStorage.getItem('pageSizeMapping')) : null;
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    localStorage.setItem('mappingPlanngoFilter', filterValue
    );
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  filterDealership(): void {
    localStorage.setItem('filterPlanngoDealershipType', this.selectedType);
    localStorage.setItem('filterPlanngoDealershipGroup', this.selectedGroup);
    localStorage.setItem('filterPlanngoDealershipActive', JSON.stringify(this.activeDealership));
    localStorage.setItem('filterPlanngoDealershipCombine', JSON.stringify(this.combineDealership));

    if ((this.selectedType == 'all' || this.selectedType == 'null') && (this.selectedGroup == 'all' || this.selectedGroup == 'null')) {
      this.dataSource.data = this.originalDataSource;
    } else if ((this.selectedType != 'all' || this.selectedType != 'null') && (this.selectedGroup == 'all' || this.selectedGroup == 'null')) {
      this.dataSource.data = this.originalDataSource.filter((e: any) => e.dealership_type_id == this.selectedType);
    } else if ((this.selectedType == 'all' || this.selectedType == 'null') && (this.selectedGroup != 'all' && this.selectedGroup != 'null)')) {
      this.dataSource.data = this.originalDataSource.filter((e: any) => e.groupe_id == this.selectedGroup);
    } else {
      this.dataSource.data = this.originalDataSource.filter((e: any) => e.groupe_id == this.selectedGroup && e.dealership_type_id == this.selectedType);
    }

    if (this.combineDealership.length > 0) {
      let dealershipArrayFiltered = [];
      if (this.combineDealership.includes('master')) {
        dealershipArrayFiltered = [...dealershipArrayFiltered, ...this.dataSource.data.filter(x => x.is_combine && x.is_combine_master)];
      }
      if (this.combineDealership.includes('child')) {
        dealershipArrayFiltered = [...dealershipArrayFiltered, ...this.dataSource.data.filter(x => x.is_combine && !x.is_combine_master)];
      }
      if (this.combineDealership.includes('not')) {
        dealershipArrayFiltered = [...dealershipArrayFiltered, ...this.dataSource.data.filter(x => !x.is_combine)];
      }
      this.dataSource.data = dealershipArrayFiltered;
    }

    if (this.activeDealership.length > 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.activeDealership.includes(e.is_active));
    }
  }
  filterGroup(event): void {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.groupsArray.filtered = this.groupsArray.default.filter((e: any) => e.nom.toLowerCase().includes(filterValue));
  }
  sortName() {
    if (this.sort == 'nameAcs') {
      this.sort = 'nameDesc';
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        return a.nom_concession < b.nom_concession ? 1 : -1;
      });
    } else {
      this.sort = 'nameAcs';
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        return a.nom_concession > b.nom_concession ? 1 : -1;
      });
    }
  }
  sortId() {
    if (this.sort == 'idAcs') {
      this.sort = 'idDesc';
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        return a.concession_id < b.concession_id ? 1 : -1;
      });
    } else {
      this.sort = 'idAcs';
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        return a.concession_id > b.concession_id ? 1 : -1;
      });
    }
  }
  focusSearch(type: string): void {
    setTimeout(() => {
      if (document.getElementById('select-search-' + type) != null) {
        // @ts-ignore
        document.getElementById('select-search-' + type).focus();
      }
    });
  }
  getDealershipType() {
    this.dataConcessionService.getDealershipType().subscribe(result => {
      this.typesArray = result;
    });
  }
  comparer(o1: any, o2: any): boolean {
    // if possible compare by object's name, and not by reference.
    return o1 && o2 ? o1 == o2 : o2 == o2;
  }
  onClickBrand(idConcession) {
    this.route.navigate(['../gestion-marque-planngo/' + idConcession]);
  }
  onClickMobilite(idConcession) {
    this.route.navigate(['../gestion-mobilite/' + idConcession]);
  }
  onClickOperation(idConcession) {
    this.route.navigate(['../gestion-operation/' + idConcession]);
  }
  onClickConfiguration(idConcession) {
    this.route.navigate(['../gestion-configuration-soft-net/' + idConcession]);
  }
  onClickSynchro(idConcession) {
    swal.fire({
      title: 'Attention',
      text: 'Lors de la synchronisation, les valeurs par défaut du catalogue générique seront appliquées à toutes les opérations. Voulez-vous continuer ?',
      type: 'warning',
      confirmButtonText: 'Ok',
      showCancelButton: true,
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        this.isSyncLoading = true;
        const error = 'Problème lors de la synchronisation de la concession ' + idConcession;
        this.dataSynchro.dealershipSynchronization(idConcession).subscribe(res => {this.showSuccessMsg();}, err => {this.showErrorMsg(error)});
      }
    });
  }
  showSuccessMsg() {
    this.isSyncLoading = false;
    swal.fire({
      title: 'Succès',
      text: 'La synchronisation a bien été effectuée.',
      type: 'success',
      confirmButtonText: 'Ok'
    });
  }
  showErrorMsg(error) {
    this.isSyncLoading = false;
    const errorMsg = error.message ? error.message : error;
    swal.fire({
      title: 'Erreur!',
      text: 'Une erreur est survenue : ' + errorMsg,
      type: 'error',
      confirmButtonText: 'Ok'
    });
  }
  getPageSizeOptions(): number[] {
    if (this.dataSource && this.dataSource.data.length > 100 && this.dataSource.paginator) {
      return [20, 50, 100,  this.dataSource.paginator.length];
    } else {
      return [20, 50, 100];
    }
  }
  displayPaginatorAllOption() {
    const matOptions = document.getElementsByClassName('mat-option-text');
    // @ts-ignore
    for (const options of matOptions) {
      options.innerHTML = options.innerHTML == this.dataSource.data.length ? 'Tous' : options.innerHTML;
    }
  }
  pageChange() {
    localStorage.setItem('pageIndexMapping', String(this.paginator.pageIndex));
    localStorage.setItem('pageSizeMapping', String(this.paginator.pageSize));
  }
  onClickInformations(idConcession) {
    this.route.navigate(['../modification-concession-pngo/' + idConcession]);
  }
}
